import { useLanguage } from '@/contexts/LanguageContext';

export const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();

  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex items-center gap-1 rounded-full px-1 py-1"
      style={{
        background: 'rgba(10,20,35,0.75)',
        border: '1px solid rgba(200,117,51,0.25)',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
      }}
    >
      {['sl', 'en'].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className="w-9 h-8 rounded-full text-xs font-mono font-bold uppercase tracking-widest transition-all duration-200"
          style={
            lang === l
              ? {
                  background: '#C87533',
                  color: '#fff',
                  boxShadow: '0 0 10px rgba(200,117,51,0.5)',
                }
              : { color: 'rgba(255,255,255,0.45)' }
          }
        >
          {l}
        </button>
      ))}
    </div>
  );
};
